/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Too_FarInputs */

const en_delivery_too_far = /** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery Warning: Over 5km limit`)
};

const es_delivery_too_far = /** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertencia de Envío: Supera el límite de 5km`)
};

const fr_delivery_too_far = /** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avertissement de livraison : Dépasse la limite de 5 km`)
};

const de_delivery_too_far = /** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferwarnung: Über 5km Limit`)
};

const id_delivery_too_far = /** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringatan Pengiriman: Melampaui batas 5km`)
};

/** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */
const ja_delivery_too_far = en_delivery_too_far;

/** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */
const zh_delivery_too_far = en_delivery_too_far;

/** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */
const ar_delivery_too_far = en_delivery_too_far;

/** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */
const it_delivery_too_far = en_delivery_too_far;

/** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */
const ru_delivery_too_far = en_delivery_too_far;

/** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */
const pt_delivery_too_far = en_delivery_too_far;

/** @type {(inputs: Delivery_Too_FarInputs) => LocalizedString} */
const ko_delivery_too_far = en_delivery_too_far;

/**
* | output |
* | --- |
* | "Delivery Warning: Over 5km limit" |
*
* @param {Delivery_Too_FarInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_too_far = /** @type {((inputs?: Delivery_Too_FarInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Too_FarInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_too_far(inputs)
	if (locale === "es") return es_delivery_too_far(inputs)
	if (locale === "fr") return fr_delivery_too_far(inputs)
	if (locale === "de") return de_delivery_too_far(inputs)
	if (locale === "ja") return ja_delivery_too_far(inputs)
	if (locale === "zh") return zh_delivery_too_far(inputs)
	if (locale === "ar") return ar_delivery_too_far(inputs)
	if (locale === "id") return id_delivery_too_far(inputs)
	if (locale === "it") return it_delivery_too_far(inputs)
	if (locale === "ru") return ru_delivery_too_far(inputs)
	if (locale === "pt") return pt_delivery_too_far(inputs)
	return ko_delivery_too_far(inputs)
});